var circleClose = "https://shopfront-cdn.tekoapis.com/static/511986a5e2d4e41e.svg";

export { circleClose as default };
